import { combineReducers } from "redux";
import users from "./users";
import auth from "./auth";
import deplete from "./deplete";
import history from "./history";
import item from "./item";
import location from "./location";
import stock from "./stock";
import receipt from "./receipt";
import request from "./request";
import requisition from "./requisition";
import locationRequest from "./locationRequest";
import locationReceived from "./locationReceived";
import locationStock from "./getLocationStock";
import locationDefault from "./locationDefaultHistory";
import locationItem from "./locationItems";
import locationReceipts from "./locationReceipts";
import singleLocationReceipt from "./singleLocationReceipt";
import adminReceivedYearlyCost from "./adminReceivedYearlyCost";
import adminStockIssuedMonthlyQuantity from "./adminStockIssuedMonthlyQuantity";
import adminStockIssuedYearlyQuantity from "./adminStockIssuedYearlyQuantity";
import locationReceivedYearlyCost from "./locationReceivedYearlyCost";
import locationStockIssuedMonthlyQuantity from "./locationStockIssuedMonthlyQuantity";
import locationStockIssuedYearlyQuantity from "./locationStockIssuedYearlyQuantity";
import received from "./received";
import forecast from "./forecast";
import CurrentPrices from "./CurrentPrices";
export default combineReducers({
  users,
  auth,
  deplete,
  history,
  item,
  location,
  stock,
  receipt,
  request,
  requisition,
  locationRequest,
  received: locationReceived,
  locationStock,
  locationDefault,
  locationItem,
  locationReceipts,
  locationReceipt: singleLocationReceipt,
  all_received: received,
  adminReceivedYearlyCost,
  adminStockIssuedMonthlyQuantity,
  adminStockIssuedYearlyQuantity,
  locationReceivedYearlyCost,
  locationStockIssuedMonthlyQuantity,
  locationStockIssuedYearlyQuantity,
  forecast,
  CurrentPrices,
});
